<template>
  <div class="col-4 text-center">
    <div>
      <WCImage
        :imageSrc="`${$configuration.cdn}/api/img/${giftCard.design.image}`"
        imageClass="img-thumbnail"
        :imageAlt="$t('giftCardImgAltText')"
        defaultClass="font-size-7xl"
      />
    </div>
    <div class="item-detail">
      <div>
        <strong>{{ giftCard.amount | currency }} {{ $t('eGiftCard') }}</strong>
      </div>
      <div>
        <strong>{{ $t('toCap') }}:</strong> {{ giftCard.recipientName }},
        <strong>{{ $t('from') }}:</strong>
        {{ giftCard.senderName }}
      </div>
      <div v-if="giftCard.message">
        <strong>{{ $t('message') }}: </strong>{{ giftCard.message }}
      </div>
      <div v-if="giftCard.sendDate">
        <strong>{{ $t('willBeSentOn') }} {{ giftCard.sendDate | formatDateTime }}</strong>
      </div>
      <button class="btn btn-primary" @click="open()" ref="viewGiftCardBtnRef">
        {{ $t('viewEGiftCard') }}
      </button>
    </div>
  </div>
</template>

<script>
import ModalService from '@/modules/modals/services/modal.service';
import WCImage from '@/components/WCImage/WCImage.vue';
import WCOrderPanelGiftCardModal from './WCOrderPanelGiftCardModal.vue';

export default {
  name: 'WCOrderPanelGiftCard',
  components: {
    WCImage,
  },
  props: {
    giftCard: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async open() {
      try {
        await ModalService.open(WCOrderPanelGiftCardModal, { giftCardProfile: this.giftCard });
      } catch (error) {
        // NOOP
      } finally {
        if (this.$refs.viewGiftCardBtnRef) this.$refs.viewGiftCardBtnRef.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.item-detail {
  padding-top: $pad-1;
  padding-bottom: $pad-1;
  border-bottom: 1px solid #aaaaaa;
  &:last-child {
    border-bottom: none;
  }

  .item-image {
    float: left;
    padding-right: $pad-3 * 0.625;
  }

  .item-text {
    display: table;
    min-height: rem(100px);
  }
}

@include media-breakpoint-down(sm) {
  @media screen and (max-width: 767px) {
    .item-detail {
      display: flex;
      flex-direction: column;
      align-items: center;

      .item-image {
        padding: 0;
      }
    }
  }
}
</style>
